export const BACKEND : string = process.env.REACT_APP_BACKEND_URL ?? '';
